
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useScrollLock } from "../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import PageTopTitle from "../shared/PageTopTitle"
import { showModal } from "../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import Button from "../shared/button/Btn"
import { handleActiveSelect } from "../../features/layout/layoutSlice"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import InputPhoneFormat from "../shared/input/new/InputPhoneFormat"
import InputText from "../shared/input/new/InputText"
import InputTextarea from "../shared/input/new/InputTextarea"
import InputNumberWithSuffix from "../shared/input/new/InputNumberWithSuffix"
import { addBlockedUsers } from "../../features/blockedUsers/blockedUserSlice"
import { nanoid } from "@reduxjs/toolkit"



const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 870px;
        max-width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            margin: 50px 30px;
            display: flex;
            width: 100%;
            flex-direction: column;
            align-items: center; 
            gap: 15px;
            .btn{
                color: var(--color-main);
                text-decoration: underline;
                cursor: pointer;
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-lg);
            }
            .col{
                display: flex;
                flex-direction: column;
                gap: 15px;
                width: 55%;
                .plate-item{
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    p{
                        width: 100px;
                    }
                }
            }
            .row{
                width: 55%;
                .error{
                    font-size: 12px;
                    color: var(--color-main);
                    margin-top: 5px;
                }
            }
            &::-webkit-scrollbar {
                width: 0;
                width: 8px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #9e9b9b;
                border-radius: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: transparent;
            }
        }

        .button-grp{
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            width: 640px;
            border-top: 1px solid;
            border-color: ${({ theme }) => theme.mainBorderColor};
            margin-right: 8px;
        }
    }

    @media (max-width: 650px){
        .modal{
            width: 100% !important;
            .row{
                width: 90% !important;
            }
        }
    }
`


const FirmaKaraListeEkleModal = () => {
    
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [isSubmitted, setIsSubmitted] = useState(false)
    const [plateList, setPlateList] = useState([
        {
            id: nanoid(),
            plate: ""
        }
    ])

    const [telefon ,setTelefon] = useState("")
    
    const [data, setData] = useState({
        "adSoyadUnvan": "",
        "tcNo": "",
        "description": ""
    })

    const addPlate = () => {
        setPlateList((prev)=> [...prev, {id: nanoid(), plate: ""}])
    }

    const removePlate = (id) => {
        setPlateList((prev)=> prev.filter((item)=> item.id !== id))
    }

    const handleChangePlate = (e, id) => {
        setPlateList((prev)=> prev.map((item)=> item.id === id ? {...item, plate: e.target.value} : item))
    }

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])


    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    const handleChange = (e)=> {
        setData((prev)=> ({...prev, [e.target.name]: e.target.value}))
    }

    const handleSubmit = () => {
        setIsSubmitted(true)
        if(data?.description && telefon){
            const addData = {
                fullNameTitle: data?.adSoyadUnvan,
                nationalId: data?.tcNo,
                blockedVehicles: plateList[0]?.plate?.length > 0 ? plateList.map((item) => {return({plate: item.plate})}) : [],
                description: data?.description,
                phoneNumber: telefon?.slice(2)
            }
            dispatch(addBlockedUsers(addData))
        }
        
    }


  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))} >
    <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
    <PageTopTitle title={"Engellenen Sürücülere Ekle"}/>
    <div className="content">
        <div className="row">
            <InputPhoneFormat data={telefon} setData={setTelefon} name={"telefon"} labelText={"Telefon"} inputWidth={"100%"} />
            {
                isSubmitted && !telefon && 
                <p className="error">Zorunlu alan!</p>
            }
        </div>
        <div className="row">
            <InputText data={data?.adSoyadUnvan} setData={(e) => handleChange(e)} name={"adSoyadUnvan"} labelText={"Ad Soyad / Unvan"} inputWidth={"100%"} />
            
        </div>
        <div className="row">
            <InputNumberWithSuffix noneSeperator data={data?.tcNo} setData={(e) => handleChange(e)} name={"tcNo"} labelText={"TC No"} inputWidth={"100%"} />
           
        </div>
        <div className="col">
            {plateList.map((item, index)=> (
                <div className="plate-item">
                    <InputText data={item?.plate} setData={(e) => handleChangePlate(e, item.id)} name={`plate${index}`} labelText={"Plaka"} inputWidth={"100%"}  />
                    {plateList?.length > 1 && <p className="btn" onClick={() => removePlate(item.id)}>Plakayı Kaldır</p>}
                </div>
            ))}
            <p className="btn" onClick={addPlate}>Plaka Ekle</p>
        </div>
        <div className="row">
            <InputTextarea data={data?.description} setData={(e) => handleChange(e)} name={"description"} labelText={"Gerekçe"} inputWidth={"100%"} />
            {
                isSubmitted && !data?.description && 
                <p className="error">Zorunlu alan!</p>
            }
        </div>
    </div>
    
    <div className='button-grp'>
        <Button handleClick={handleSubmit} bgColor="#E85446" width="150px" color="#fff">Kaydet</Button>
        <Button handleClick={() => dispatch(showModal(null))} bgColor="transparent" width="150px" color="#E85446">Kapat</Button>
    </div>
    </div>
</ModalContainer>
  )
}

export default FirmaKaraListeEkleModal